export const HEALTH_CONDITIONS = [
    { id: "high_blood_pressure", label: "High blood pressure" },
    { id: "type_2_diabetes", label: "Type 2 Diabetes" },
    { id: "type_1_diabetes", label: "Type 1 Diabetes" },
    { id: "pre_diabetes", label: "Pre-diabetes" },
    { id: "high_cholesterol", label: "High cholesterol" },
    { id: "ckd", label: "Chronic kidney disease (CKD)" },
    { id: "celiac", label: "Celiac disease" },
    { id: "lactose_intolerance", label: "Lactose intolerance" },
    { id: "ibs_ibd", label: "IBS / IBD" },
    { id: "heart_disease", label: "Heart disease" },
    { id: "fatty_liver", label: "Fatty liver" },
    { id: "hypothyroidism", label: "Hypothyroidism" },
];
